import React, {memo, useState} from 'react';
import PropTypes from 'prop-types';
import {Form, Table, Typography} from 'antd';
import {useTranslation} from 'react-i18next';
import DeleteBin5LineIcon from 'remixicon-react/DeleteBin5LineIcon';
import styles from './index.less';
import SelectUsersAreaAccess from '@/modules/users/components/SelectUsersAreaAccess';
import SelectAreaAccessRegisters from '@/modules/users/components/SelectAreaAccessRegisters';
import SelectUserCategory from '@/modules/users/components/SelectUserCategory';
import {usersRegistersAccessColumns} from '@/modules/users/contants/userRegisterAccess.columns';

const { Text } = Typography;

// const pattern = new RegExp('^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$');

// eslint-disable-next-line no-unused-vars
const UserRegisterAccess = ({value, form, initialValues, ...props}) => {
  const {t} = useTranslation('users');
  const [areaAccess, setAreaAccess] = useState('');
  const [category, setCategory] = useState('');
  const [formChanged, setFormChanged] = useState(false);

  return (
    <Form.List name={'registersAccess'}>
      {(fields, { add, remove }) => (
        <>
          {fields.map(({key,...restField}) => (
            <div key={key} className="mb-3 flex items-start justify-items-start">
              <Form.Item
                {...restField}
                name={[restField.name, 'areaAccess']}
                className="mb-0 mr-1"
                label={t('areaAccess')}
                rules={[
                  {
                    required: true,
                  }
                ]}
              >
                <SelectUsersAreaAccess key={`areaAccess-${restField.name}`} translation={t} defaultValue={value?.[restField?.name]?.areaAcccess || null} fieldKey={restField?.name} form={form} setAreaAccess={setAreaAccess} formChanged={formChanged} {...props}/>
              </Form.Item>
              <Form.Item
                {...restField}
                name={[restField.name, 'category']}
                className="mb-0 truncate w-full"
                label={t('category')}
                rules={[
                  {
                    required: true,
                  }
                ]}
              >
                <SelectUserCategory key={`category-${restField.name}-${category || ''}`} translation={t} defaultValue={value?.[restField?.name]?.category} fieldKey={restField?.name} form={form} setCategory={setCategory} formChanged={formChanged} {...props}/>
              </Form.Item>
              <Form.Item
                {...restField}
                name={[restField.name, 'registers']}
                className="mb-0 ml-1 truncate w-full"
                label={t('registers')}
                rules={[
                  {
                    required: true,
                  }
                ]}
              >
                <SelectAreaAccessRegisters key={`registers-${restField.name}-${areaAccess}-${category}`} defaultValue={value?.[restField?.name]?.registers} areaAccess={areaAccess} category={category} fieldKey={restField?.name} form={form} translation={t} {...props}/>
              </Form.Item>
              <Form.Item
                className="mb-0 flex items-center mt-8"
              >
                <div className={styles.wrapperRemove}>
                  <DeleteBin5LineIcon className={`ml-2 ant-icon ${styles.removeIcon}`} onClick={() => {
                    remove(restField?.name);
                  }}/>
                </div>
              </Form.Item>
            </div>
          ))}
          <Text className={styles.actionBtn} onClick={() => {
            setFormChanged(true);
            add();
          }}>{t('user.form.areaAccessRegisters.add')}</Text>
        </>
      )}
    </Form.List>
  );
};

UserRegisterAccess.propTypes = {
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  subText: PropTypes.string,
  formName: PropTypes.string,
  value: PropTypes.any,
  form: PropTypes.any,
  initialValues: PropTypes.any
};

UserRegisterAccess.defaultProps = {
  required: true,
};

export default memo(UserRegisterAccess);

// eslint-disable-next-line react/prop-types
const UserRegisterAccessView = ({entity}) => {
  return (
    <div>
      <Table columns={usersRegistersAccessColumns} dataSource={entity}/>
    </div>
  );
};

UserRegisterAccessView.propTypes = {
  value: PropTypes.array
};


/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the DynamicEmails component in a table cell
 * @param {String} text this is the value of the dataIndex of the table (we will ignored in this case)
 * */
export const renderUserRegisterAccess = (text) => {
  return (
    <UserRegisterAccessView entity={text}/>
  );
};
